export default __webpack_public_path__ + "static/Nunito-Regular-9d7a6e03c6e3ed49c7ac09450bb21482.ttf";